import { DateTime } from 'luxon';

/** Как в Яндекс Трекере: «09 окт, 17:06», год — только если не текущий */
export const formatCommentTime = (iso: string) => {
  const time = DateTime.fromISO(iso).setLocale('ru');
  const format = time.hasSame(DateTime.now(), 'year') ? 'dd MMM, HH:mm' : 'dd MMM yyyy, HH:mm';

  // Intl сокращает месяц с точкой («окт.»), у Яндекса — без
  return time.toFormat(format).replace('.', '');
};
